import React, { useEffect, useRef, useState, useContext } from "react";
import { images } from "common/images";
import { MAIN_SITE_URL } from "common";
import "./style.scss";
import { ApplicationContext } from "shared";

export const MedicalCard = (data) => {
  const {
    firstName,
    lastName,
    birthDate,
    organDonation,
    emergencyNumber,
    nationality,
    insuranceCompany,
    policyNumber,
    ssn,
    medicalNotes,
  } = data;

  const preRef = useRef(null);
  const [isBack, setBack] = useState(false);
  const { categoryListing } = useContext(ApplicationContext);

  useEffect(() => {
    const pre = preRef.current;
    if (pre) {
      // Set the initial rotation (front or back)
      pre.style.setProperty("--rotateX", `${isBack ? 180 : 0}deg`);
      pre.style.setProperty("--rotateY", `0deg`);
    }
  }, [isBack]);

  const flipCard = () => {
    setBack((prev) => !prev);
  };

  function getDescriptionsWithComma(dataListing) {
    if (!dataListing || dataListing.length === 0) return "-";
    return dataListing.map((el) => el.description).join(", ");
  }
  //
  return (
    <div className="medical-card-container">
      <div ref={preRef} className="medical-card" onClick={flipCard}>
        <div className="front-side">
          <div className="card-side top-info">Medical Information Inside</div>
          <div className="card-side bottom-info">Emergency Medical Card</div>
          <div className="card-side left-info">Medical Card</div>
          <div className="card-side right-info">Break Seal to Open</div>
          <div className="break-border"></div>
          <div className="inside">
            <div className="logo-info">
              <div className="logo-left">
                <span className="ask">Issued on</span>
                <span className="val">{MAIN_SITE_URL?.replace(/^https?:\/\//, '')}</span>
              </div>
              <div className="logo-right">
                <img
                  src={images.wmcLogo}
                  width="100px"
                  alt="no-image"
                  style={{ borderRadius: 0 }}
                />
              </div>
            </div>
            <div className="card-data">
              <div className="card-desc">
                <span className="ask">Name</span>
                {firstName ? (
                  <span className="reply">
                    {firstName} {lastName}
                  </span>
                ) : (
                  <span className="reply">Your Name Here</span>
                )}
              </div>
              <div className="card-desc">
                <span className="ask">Travel Insurance Company</span>
                <span className="val">{insuranceCompany}</span>
              </div>
              <div className="card-desc-data">
                <div className="card-desc">
                  <span className="ask">Policy No:</span>
                  <span className="val">{policyNumber}</span>
                </div>
                <div className="card-desc">
                  <span className="ask">Emergency Phone No:</span>
                  <span className="val">{emergencyNumber}</span>
                </div>
              </div>
              <div className="card-desc-data">
                <div className="card-desc">
                  <span className="ask">National ID number or similar:</span>
                  <span className="val">{ssn}</span>
                </div>
                <div className="card-desc">
                  <span className="ask">Nationality</span>
                  <span className="val">{nationality}</span>
                </div>
              </div>
              <div className="card-desc-data">
                <div className="card-desc">
                  <span className="ask">Date of Birth:</span>
                  <span className="val">{birthDate}</span>
                </div>
                <div className="card-desc">
                  <span className="ask">Organ Donation</span>
                  <span className="val">{organDonation ? "Yes" : "No"}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="back-side">
          <div className="card-side top-info">Emergency Medical Card</div>
          <div className="card-side bottom-info">
            Medical Information Inside
          </div>
          <div className="card-side left-info">Break Seal to Open</div>
          <div className="card-side right-info">Medical Card</div>
          <div className="break-border"></div>
          <div className="inside">
            <div className="card-data card-data-spacing">
              <div className="card-desc">
                <span className="ask">Diagnosis (based on ICD-11)</span>
                <span className="val">
                  {categoryListing?.length > 0
                    ? getDescriptionsWithComma(categoryListing[0].dataListing)
                    : "-"}
                </span>
              </div>
              <div className="card-desc">
                <span className="ask">Medications (based on ATC)</span>
                <span className="val">
                  {categoryListing?.length > 0
                    ? getDescriptionsWithComma(categoryListing[1].dataListing)
                    : "-"}
                </span>
              </div>
              <div className="card-desc">
                <span className="ask">Allergies</span>
                <span className="val">
                  {categoryListing?.length > 0
                    ? getDescriptionsWithComma(categoryListing[2].dataListing)
                    : "-"}
                </span>
              </div>
              <div className="card-desc">
                <span className="ask">Vaccines</span>
                <span className="val">
                  {categoryListing?.length > 0
                    ? getDescriptionsWithComma(categoryListing[3].dataListing)
                    : "-"}
                </span>
              </div>
              {medicalNotes ? (
                <div className="card-desc">
                  <span className="ask">Additional information</span>
                  <span className="val">{medicalNotes}</span>
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
